document.addEventListener("DOMContentLoaded", function () {
  // Handle scroll events
  const handleScroll = () => {
    document.body.classList.toggle("scrolled", window.scrollY >= 100);
  };

  handleScroll();
  window.addEventListener("scroll", handleScroll);
});

// Aninated CSS
function animateCSS(element, animationName, callback) {
  element.classList.add('animate__animated', `animate__${animationName}`);

  function handleAnimationEnd() {
    element.classList.remove('animate__animated', `animate__${animationName}`);
    element.removeEventListener('animationend', handleAnimationEnd);
    if (typeof callback === 'function') callback();
  }

  element.addEventListener('animationend', handleAnimationEnd);
}

// Make sure js calculation match with Liquid
function calcPercentLiquidStyle(compare, price) {
  compare = parseInt(compare, 10);
  price = parseInt(price, 10);
  if (!compare || compare <= price) return 0;
  var diff = compare - price;
  var times100 = diff * 100;
  var divided = Math.floor(times100 / compare); 
  return Math.round(divided);
}